(ns frontend.view.settings2.contact-lists.contact-lists
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.not-found :as not-found]
   [frontend.view.settings2.contact-lists.event :as event]
   [frontend.view.settings2.sales-pipelines.db :as db]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.breadcrumbs.view :as breadcrumbs]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.avatar.view :as avatar]
   [ui.components.radix-ui.tooltip.view :as tooltip]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/contact-lists)]])

(defn card
  [content]
  [:div
   content])

(defn avatar-group
  [{:keys [_person-or-account-ids]}]
  (let [container-ref-state (r/atom nil)
        avatar-width 35
        max-avatars-state (r/atom nil)
        set-max-avatars (fn [container-width]
                          (let [max-avatars (-> (/ container-width avatar-width)
                                                Math/floor
                                                (dec)
                                                (dec))]
                            (reset! max-avatars-state max-avatars)))
        resize-listener (fn []
                          (when-let [container-ref @container-ref-state]
                            (let [rect (.getBoundingClientRect container-ref)
                                  width (.-width rect)]
                              (set-max-avatars width))))]
    (r/create-class
     {:component-did-mount    (fn []
                                (when-let [container-ref @container-ref-state]
                                  (let [rect (.getBoundingClientRect container-ref)
                                        width (.-width rect)]
                                    (set-max-avatars width)))
                                (.addEventListener js/window "resize" resize-listener))
      :component-will-unmount (fn []
                                (.removeEventListener js/window "resize" resize-listener))
      :reagent-render
      (fn [{:keys [person-or-account-ids]}]
        (let [person-count (count person-or-account-ids)
              max-avatars-count @max-avatars-state
              shown-avatar-count (max max-avatars-count 1)

              hidden-avatar-count (- person-count shown-avatar-count)
              shown-avatar-count (if (= 1 hidden-avatar-count)
                                   (inc shown-avatar-count)
                                   shown-avatar-count)
              hidden-avatar-count (if (= hidden-avatar-count 1)
                                    0
                                    hidden-avatar-count)
              hidden-avatars (when (< 0 hidden-avatar-count)
                               (drop shown-avatar-count person-or-account-ids))
              hidden-avatars? (< 0 hidden-avatar-count)
              visible-avatars (take shown-avatar-count person-or-account-ids)]
          [:div
           {:class "relative flex -space-x-2"
            :ref   (fn [ref]
                     (reset! container-ref-state ref))}
           (when @max-avatars-state
             (->> visible-avatars
                  (map-indexed (fn [index entity-id]
                                 (let [entity (session/get-entity entity-id)
                                       last-avatar? (= index (- shown-avatar-count 1))
                                       entity-label (entity/display-string entity)
                                       initials (entity/get-initials entity)
                                       image-url (:account/picture-url entity)]
                                   ^{:key (str "contact-list-member-" entity-id)}
                                   [:div
                                    [:div
                                     [tooltip/view
                                      [:span
                                       [avatar/view
                                        {:image-url image-url
                                         :fallback  initials}]]
                                      [:span entity-label]]]
                                    (when (and hidden-avatars?
                                               last-avatar?)
                                      [:div
                                       {:style {:position "absolute"
                                                :top      "0"
                                                :left     (str (* (inc index) avatar-width) "px")}}
                                       [tooltip/view
                                        [:span
                                         [avatar/view
                                          {:image-url nil
                                           :fallback  (str "+" hidden-avatar-count)}]]
                                        [:div
                                         {:style {:display        "flex"
                                                  :flex-direction "column"}}
                                         (->> hidden-avatars
                                              (map (fn [id]
                                                     (let [entity (session/get-entity id)
                                                           label (entity/display-string entity)]
                                                       ^{:key (str "hidden-avatar-" id)}
                                                       [:span label])))
                                              (doall))]]])])))
                  (doall)))]))})))

(defn no-entities-view
  []
  [:div
   {:class "py-5 flex flex-col items-center text-center"}
   [:img
    {:src   "/img/no-result-found.svg"
     :class "max-w-64"}]
   [:strong
    {:class "my-6 block text-complement-light-text text-md font-bold"}
    "You don't have any Contact Lists yet"]
   (when-not (session/is-read-only-user?)
     [button/sm-primary-solid
      {:on-click #(rf/dispatch [::event/set-selected-contact-list "create-new"])}
      [:i.fal.fa-plus]
      "Create Contact List"])])

(defn contact-lists-view
  []
  (let [contact-lists @session/contact-lists]
    [:div
     {:class "flex flex-col gap-4"}
     
     (if (seq contact-lists)
       [:div
        {:class "flex flex-col gap-4"}
        [:div
         {:class "flex justify-between items-center"}
         [:span
          {:class "text-xl font-bold"}
          "Contact Lists"]
          [:div
          [button/sm-primary-solid
           {:size     :small
            :on-click #(rf/dispatch [::event/set-selected-contact-list "create-new"])}
           [:i.fal.fa-plus]
           "Create Contact List"]]
         ]
       
        [:div
         {:class "border border-solid border-base-light-border-paler rounded-lg overflow-x-auto"}
         [:table
          {:class "min-w-full divide-y divide-solid divide-base-light-border-paler"}
          [:thead
           [:tr
            {:class "*:px-3 *:py-3.5 *:text-left *:text-sm *:font-semibold *:text-base-light-text"}
            [:th
             "Name"]
            [:th
             "Members"]]]
          [:tbody
           {:class "divide-y divide-solid divide-base-light-border-paler"}
           (->> contact-lists
                (map (fn [contact-list]
                       (let [id (:db/id contact-list)
                             title (:contact-list/title contact-list)
                             members (:contact-list/members contact-list)]
                         ^{:key (str "contact-list-" id)}
                         [:tr
                          {:class    "*:px-3 *:py-3 *:whitespace-nowrap *:text-sm *:text-base-light-text *:align-middle"
                           :on-click #(rf/dispatch [::event/set-selected-contact-list id])}
                          [:td 
                           title]
                          [:td
                           [avatar-group
                            {:person-or-account-ids members}]]])))
                (doall))]]]]
       [:div
        [no-entities-view]])]))


(defn component
  []
  (fn []
    [:<>
     [zap-toolbar/view db/state breadcrumbs nil nil]
     [:div
      {:class "px-4 py-6 lg:mx-auto lg:w-5xl"}
      [:div
       [:div
        [card
         [contact-lists-view]]]]]]))

(defmethod routing/render-view :settings/contact-lists
  [_]
  (if (session/contact-lists?)
    [default-page-layout/view
     [component]]
    [not-found/not-found-view]))
